
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoenixAccountHotelMediaContentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HotelMediaContent"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoGallery"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"suites"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hotelView"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"guestRoomFloorPlan"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"dining"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"eventsAndMeetings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"golf"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"guestRooms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recreationAndFitness"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"phoenixAccountProductImageConnectionFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1014}};
    doc.loc.source = {"body":"#import \"./phoenixAccountProductImageConnectionFragment.graphql\"\n\nfragment phoenixAccountHotelMediaContentFragment on HotelMediaContent {\n  photoGallery {\n    features {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    suites {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    hotelView {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    guestRoomFloorPlan {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    activities {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    services {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    dining {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    eventsAndMeetings {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    golf {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    guestRooms {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n    recreationAndFitness {\n      ...phoenixAccountProductImageConnectionFragment\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./phoenixAccountProductImageConnectionFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["phoenixAccountHotelMediaContentFragment"] = oneQuery(doc, "phoenixAccountHotelMediaContentFragment");
        
